export default "__VITE_ASSET__9e2a1b4a__"